import styles from './Footer.less';

import React, { Component, PropTypes } from 'react';
import { ChevronIcon } from 'seek-style-guide/react';

import { ScreenReaderOnly } from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';

export default class Footer extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired
  };

  shouldComponentUpdate(nextProps) {
    return this.props.locale !== nextProps.locale;
  }

  render() {
    const { locale } = this.props;
    const isAU = locale === 'AU';
    const isNZ = locale === 'NZ';
    const domainSuffix = isNZ ? 'co.nz' : 'com.au';

    return (
      <footer role="contentinfo" className={styles.root}>
        <section>
          <ScreenReaderOnly>
            <h1>Footer</h1>
          </ScreenReaderOnly>

          <div className={styles.content}>
            <FooterNav label="Tools">
              <FooterLink analytics="toolbar:profile" href="/profile/">Profile</FooterLink>
              <FooterLink analytics="toolbar:my+activity" href="/myactivity#favourite">Saved searches</FooterLink>
              <FooterLink analytics="toolbar:favourite" href="/my-activity/saved-jobs">Saved jobs</FooterLink>
              <FooterLink analytics="toolbar:applied" href="/my-activity/applied-jobs">Applied jobs</FooterLink>
              <FooterLink analytics="toolbar:advice+tips" href="/career-advice/">Advice &amp; tips</FooterLink>
              <FooterLink analytics="toolbar:companies" href="/companies/" visible={isAU}>Company reviews</FooterLink>
            </FooterNav>

            <FooterNav label="Company">
              <FooterLink analytics="toolbar:about+seek" href="/investor/about-us">About SEEK</FooterLink>
              <FooterLink analytics="toolbar:media" href="/investor/news-media">Media</FooterLink>
              <FooterLink analytics="toolbar:work+for+seek" href="/work-for-seek">Work for SEEK</FooterLink>
              <FooterLink analytics="toolbar:investor+centre" href="https://ir.seek.com.au">Investor centre</FooterLink>
              <ToggleContainer name="InternationalPartnersToggle" label="International partners">
                <FooterLink partner="India" analytics="toolbar:babajob" href="http://www.babajob.com">BabaJob</FooterLink>
                <FooterLink partner="Bangladesh" analytics="toolbar:bdjobs" href="http://www.bdjobs.com">Bdjobs</FooterLink>
                <FooterLink partner="E Africa" analytics="toolbar:brighter+monday" href="https://www.brightermonday.com">Brighter Monday</FooterLink>
                <FooterLink partner="Brazil" analytics="toolbar:catho" href="http://www.catho.com.br">Catho</FooterLink>
                <FooterLink partner="W Africa" analytics="toolbar:jobberman" href="http://www.jobberman.com">Jobberman</FooterLink>
                <FooterLink partner="SE Asia" analytics="toolbar:jobsdb" href="http://www.jobsdb.com">jobsDB</FooterLink>
                <FooterLink partner="SE Asia" analytics="toolbar:jobstreet" href="http://www.jobstreet.com">JobStreet</FooterLink>
                <FooterLink partner="Worldwide" analytics="toolbar:jora+int" href="https://www.jora.com">Jora</FooterLink>
                <FooterLink partner="Brazil" analytics="toolbar:manager" href="http://www.manager.com.br">Manager</FooterLink>
                <FooterLink partner="Mexico" analytics="toolbar:occ+mundial" href="https://www.occ.com.mx">OCC Mundial</FooterLink>
                <FooterLink partner="Latin America" analytics="toolbar:workana" href="https://www.workana.com">Workana</FooterLink>
                <FooterLink partner="China" analytics="toolbar:zhaopin" href="http://www.zhaopin.com">Zhaopin</FooterLink>
                <FooterLink partner="Australia" analytics="toolbar:jora+au" href="https://au.jora.com">Jora</FooterLink>
              </ToggleContainer>
              <ToggleContainer name="PartnerServicesToggle" label="Partner services" visible={isAU}>
                <FooterLink analytics="toolbar:jobadder" href="https://jobadder.com/au">JobAdder</FooterLink>
                <FooterLink analytics="toolbar:jora+local" href="http://www.joralocal.com.au">Jora Local</FooterLink>
                <FooterLink analytics="toolbar:realestate+au" href="https://www.realestate.com.au/buy">realestate.com.au</FooterLink>
                <FooterLink analytics="toolbar:sidekicker" href="https://www.sidekicker.com.au/">Sidekicker</FooterLink>
                <FooterLink analytics="toolbar:ximble" href="https://www.ximble.com">Ximble</FooterLink>
              </ToggleContainer>
            </FooterNav>

            <FooterNav label="Connect">
              <FooterLink analytics="toolbar:contact+us" href="/contact-us">Contact us / FAQs</FooterLink>
              <FooterLink analytics="toolbar:product+blog" href="http://productblog.seek.com.au">Product &amp; Tech Blog</FooterLink>
              <ToggleContainer name="SocialToggle" label="Social">
                <FooterLink analytics="toolbar:facebook" href="https://www.facebook.com/SEEK/" visible={isAU}>Facebook</FooterLink>
                <FooterLink analytics="toolbar:facebook" href="https://www.facebook.com/seeknz/" visible={isNZ}>Facebook</FooterLink>
                <FooterLink analytics="toolbar:instagram" href="https://www.instagram.com/seekau/" visible={isAU}>Instagram</FooterLink>
                <FooterLink analytics="toolbar:instagram" href="https://www.instagram.com/seeknz/" visible={isNZ}>Instagram</FooterLink>
                <FooterLink analytics="toolbar:twitter" href="https://twitter.com/seekjobs" visible={isAU}>Twitter</FooterLink>
                <FooterLink analytics="toolbar:twitter" href="https://twitter.com/seekjobsnz" visible={isNZ}>Twitter</FooterLink>
                <FooterLink analytics="toolbar:youtube" href="https://www.youtube.com/user/SEEKJobs">YouTube</FooterLink>
              </ToggleContainer>
            </FooterNav>

            <FooterNav label="Employers">
              <FooterLink analytics="toolbar:register+for+free" href={`https://talent.seek.${domainSuffix}/`}>Register for free</FooterLink>
              <FooterLink analytics="toolbar:post+a+job+ad" href={`https://talent.seek.${domainSuffix}/`}>Post a job ad</FooterLink>
              <FooterLink analytics="toolbar:products+prices" href={`https://talent.seek.${domainSuffix}/Support/OurProducts`}>Products &amp; prices</FooterLink>
              <FooterLink analytics="toolbar:customer+service" href={`https://talent.seek.${domainSuffix}/ContactUs`}>Customer service</FooterLink>
              <FooterLink analytics="toolbar:insight+blog" href={`http://insightsresources.seek.${domainSuffix}`}>Insights &amp; Resources</FooterLink>
            </FooterNav>

            <nav className={styles.copyright}>
              <ScreenReaderOnly>
                <h1>Additional Links</h1>
              </ScreenReaderOnly>

              <ExternalLink analytics="toolbar:privacy" className={styles.navLink} href="/privacy">Privacy</ExternalLink>
              <ExternalLink analytics="toolbar:terms+conditions" className={styles.navLink} href="/terms">Terms &amp; Conditions</ExternalLink>
              <ExternalLink analytics="toolbar:seek+safely" className={`${styles.navLink} ${styles.secondaryLink}`} href="/safe-job-searching">SEEK safely</ExternalLink>
              <ExternalLink analytics="toolbar:site+map" className={`${styles.navLink} ${styles.secondaryLink}`} href="/sitemap">Site Map</ExternalLink>
              <p className={styles.copyrightMessage}>{'\u00A9 SEEK. All rights reserved.'}</p>
            </nav>
          </div>
        </section>
      </footer>
    );
  }
}

/* eslint-disable react/no-multi-comp */
class ToggleContainer extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    visible: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ])
  };

  render() {
    const { children, label, name, visible } = this.props;

    if (visible === false) {
      return null;
    }

    return (
      <li>
        <input id={name} className={styles.toggle} type="checkbox" />
        <label className={`${styles.navLink} ${styles.toggleLabel}`} htmlFor={name}>
          {label}
          <ChevronIcon direction="down" className={ styles.chevron } svgClassName={ styles.chevronSvg } />
        </label>
        <ul className={ styles.toggleContainer }>
          { children }
        </ul>
      </li>
    );
  }
}

class FooterLink extends Component {
  static propTypes = {
    analytics: PropTypes.string,
    href: PropTypes.string,
    visible: PropTypes.bool,
    className: PropTypes.string,
    partner: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ])
  };

  render() {
    const { partner, analytics, href, children, visible, className } = this.props;

    // "visible === undefined" is equivalent to "visible === true" when visible is not passed in the react attributes;
    if (visible === false) {
      return null;
    }

    return (
      <li className={ className }>
        <ExternalLink className={ styles.navLink } analytics={ analytics } href={ href }>{ children }</ExternalLink>
        { partner && (<Partner partner={partner} />) }
      </li>
    );
  }
}

class Partner extends Component {
  static propTypes = {
    partner: PropTypes.string
  };

  render() {
    const { partner } = this.props;

    return (
      <span className={styles.internationalPartnerCountry}>{` — ${partner}`}</span>
    );
  }
}

class FooterNav extends Component {
  static propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ])
  };

  render() {
    const { label, children, className } = this.props;

    return (
      <nav className={className || styles.category}>
        <h1 className={styles.heading}>{label}</h1>
        <ul className={styles.list}>
          { children }
        </ul>
      </nav>
    );
  }
}
/* eslint-enable react/no-multi-comp */



/** WEBPACK FOOTER **
 ** ./app/components/Footer/Footer.js
 **/